var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5625C8.64921 1.55868 9.77617 1.87924 10.7513 2.48733C11.7265 3.09542 12.5102 3.96635 13.0125 5C11.9812 7.10625 9.875 8.4375 7.5 8.4375C5.125 8.4375 3.01875 7.10625 1.9875 5C2.48976 3.96635 3.27352 3.09542 4.24867 2.48733C5.22383 1.87924 6.35079 1.55868 7.5 1.5625ZM7.5 0.3125C4.375 0.3125 1.70625 2.25625 0.625 5C1.70625 7.74375 4.375 9.6875 7.5 9.6875C10.625 9.6875 13.2937 7.74375 14.375 5C13.2937 2.25625 10.625 0.3125 7.5 0.3125ZM7.5 3.4375C7.9144 3.4375 8.31183 3.60212 8.60485 3.89515C8.89788 4.18817 9.0625 4.5856 9.0625 5C9.0625 5.4144 8.89788 5.81183 8.60485 6.10485C8.31183 6.39788 7.9144 6.5625 7.5 6.5625C7.0856 6.5625 6.68817 6.39788 6.39514 6.10485C6.10212 5.81183 5.9375 5.4144 5.9375 5C5.9375 4.5856 6.10212 4.18817 6.39514 3.89515C6.68817 3.60212 7.0856 3.4375 7.5 3.4375ZM7.5 2.1875C5.95 2.1875 4.6875 3.45 4.6875 5C4.6875 6.55 5.95 7.8125 7.5 7.8125C9.05 7.8125 10.3125 6.55 10.3125 5C10.3125 3.45 9.05 2.1875 7.5 2.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5fe40238f79da1b994215f5974109854.svg";
export { ForwardRef as ReactComponent };